/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionSdkSubmitVideoResponse } from '../../models/vision-sdk-submit-video-response';

export interface VisionSdkCompileVideoPost$Params {
  measurementId?: string;
  scanSessionId?: string;
  name?: string;
  totalPartNumbers?: number;
}

export function visionSdkCompileVideoPost(http: HttpClient, rootUrl: string, params?: VisionSdkCompileVideoPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionSdkSubmitVideoResponse>> {
  const rb = new RequestBuilder(rootUrl, visionSdkCompileVideoPost.PATH, 'post');
  if (params) {
    rb.query('measurementId', params.measurementId, {});
    rb.query('scanSessionId', params.scanSessionId, {});
    rb.query('name', params.name, {});
    rb.query('totalPartNumbers', params.totalPartNumbers, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionSdkSubmitVideoResponse>;
    })
  );
}

visionSdkCompileVideoPost.PATH = '/VisionSdk/CompileVideo';
